module.exports = __webpack_public_path__ + "media/images/admin/icons/x-circle-605614302510ae44b86017eca4440dc7.svg";